import { useParams } from 'react-router-dom';
import useStepDoc from '@actions/services/firestore/browser/playbook/version/step/use';
import EntityBreadcrumb from '../EntityBreadcrumb';
import resolvePlaybookStepBreadcrumbLabel from './helpers/resolvePlaybookStepBreadcrumbLabel';
import type { PlaybookStepCrumbProps } from './types';

const PlaybookStepCrumb = ({ param, isCurrentPage = true }: PlaybookStepCrumbProps) => {
    const params = useParams();
    const playbookId = params.playbookId || '';
    const versionId = params.versionId || '';
    const stepId = params[param] || '';
    const { data: step, isLoading: isLoadingStep } = useStepDoc(playbookId, versionId, stepId, {
        disabled: !playbookId || !versionId || !stepId,
    });

    const label = resolvePlaybookStepBreadcrumbLabel({
        stepId,
        stepName: step?.name ?? null,
        isLoadingStep,
    });

    return (
        <EntityBreadcrumb
            label={label}
            entityId={stepId}
            entityType="Step"
            isCurrentPage={isCurrentPage}
            isLoading={isLoadingStep && label === '...'}
        />
    );
};

export default PlaybookStepCrumb;
